import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"py-3",class:_vm.colorClass,staticStyle:{"overflow":"hidden"},attrs:{"to":_vm.to,"dark":_vm.dark},on:{"click":function($event){return _vm.click()}}},[_c(VRow,{staticClass:"px-3",attrs:{"align":"center"}},[_c(VCol,[_c('h3',[_vm._v(_vm._s(_vm.text))])])],1),_c(VIcon,{staticClass:"card-icon",attrs:{"size":50}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }